// shared settings for all xero actions

import { API_URL } from 'config';


export const XERO_BASE_URL = `${API_URL}xero/`;
